import { defineComponent as _defineComponent } from 'vue';
import { Form } from 'Components/primitives/form';
import { computed, ref, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnForm',
    props: {
        validationSchema: { type: null, required: false },
        initialValues: { type: null, required: false },
        keepValues: { type: Boolean, required: false, default: false },
        validateOnMount: { type: Boolean, required: false, default: true }
    },
    emits: ["submit", "invalid-submit"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const form = ref();
        onMounted(() => {
            if (props.validateOnMount) {
                validate();
            }
        });
        function resetValidation() {
            form.value.resetForm({ values: form.value.getValues() }, { force: true });
        }
        async function validate() {
            await nextTick();
            const result = await form.value.validate();
            form.value.setTouched(Object.keys(result.errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}));
            return result.valid;
        }
        const emit = __emit;
        const isValid = computed(() => {
            return form.value?.meta.valid;
        });
        __expose({
            isValid,
            resetValidation,
            validate,
        });
        function onSubmit(values, actions) {
            emit('submit', values, actions);
        }
        function onInvalidSubmit(actions) {
            emit('invalid-submit', actions);
        }
        const __returned__ = { props, form, resetValidation, validate, emit, isValid, onSubmit, onInvalidSubmit, get Form() { return Form; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
